define("shared/utils/time-helpers/create-and-format-moment-in-tz", ["exports", "lodash", "shared/utils/time-helpers/create-moment-in-tz"], function (_exports, _lodash, _createMomentInTz) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash",0,"shared/utils/time-helpers/create-moment-in-tz"eaimeta@70e063a35619d71f
  /**
   * Takes the unix timestamp(s) and returns the
   * moment object in the local timezone in the format provided.
   *
   * @param date unix timestamp or array of unix timestamps
   * @param timezone the timezone name
   * @param format format to display with moment
   *
   * @returns Formatted date string in provided timezone
   */
  function createAndFormatMomentInTz(date, timezone, format) {
    const isDateRange = (0, _lodash.isArray)(date);
    if (isDateRange) {
      return date.map(date => (0, _createMomentInTz.default)(Number(date), timezone).format(format));
    }
    return (0, _createMomentInTz.default)(Number(date), timezone).format(format);
  }
  var _default = _exports.default = createAndFormatMomentInTz;
});